import React from "react";
import { Collapse } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { KeyboardArrowUp, KeyboardArrowDown } from "@mui/icons-material";

const CategorySection = ({ title, count, Icon, children }) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = React.useState(true);
  const OpenIcon = isOpen ? KeyboardArrowUp : KeyboardArrowDown;

  return (
    <div className={classes.root}>
      <div className={classes.head} onClick={() => setIsOpen(!isOpen)}>
        <Icon sx={{ color: "#4F39F6", fontSize: 20 }} />
        <span className={classes.headTitle}>{title}</span>
        <span className={classes.headBadge}>{count}</span>
        <OpenIcon sx={{ marginLeft: "auto", fontSize: 24, color: "#71717A" }} />
      </div>
      <Collapse in={isOpen}>
        <div className={classes.body}>
          {children}
        </div>
      </Collapse>
    </div>
  )
}

const useStyles = makeStyles(() => ({
  root: {
    borderRadius: 8,
    border: "1px solid #E4E4E7",
    backgroundColor: "#FAFAFA",
    overflow: "hidden",
  },
  head: {
    gap: 10,
    height: 48,
    display: "flex",
    cursor: "pointer",
    padding: "0 16px",
    alignItems: "center",
    "&:hover": { backgroundColor: "#F4F4F5" },
  },
  headTitle: {
    fontSize: 14,
    color: "#27272A",
    fontWeight: 600,
    lineHeight: "20px",
  },
  headBadge: {
    fontSize: 12,
    fontWeight: 500,
    color: "#432DD7",
    backgroundColor: "#E0E7FF",
    borderRadius: 16,
    padding: "2px 8px",
    lineHeight: "18px",
  },
  body: {
    margin: "0 8px 8px",
    padding: 12,
    borderRadius: 8,
    backgroundColor: "#FFFFFF",
  },
}));

export default CategorySection;
